import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const CallupHead = Loadable({
    loader: () => import(/* webpackChunkName: "CallupHead" */ './callupHead'),
    loading: () => <div />,
});
export const CallupVideoAppHead = Loadable({
    loader: () => import(/* webpackChunkName: "CallupVideoAppHead" */ './callupVideoAppHead/'),
    loading: () => <div />,
});
